namespace SolovisGateway.Admin.EvestmentSync {
    /**
        * Control to show the Evestment sync jobs
    */
    export class JobsListControl extends Solovis.UI.BaseControl {

        private _jobList: Array<JobItemListModel>;
        private _dataGrid: DevExpress.ui.dxDataGrid;


        constructor(options) {
            super(options);

            this._jobList = new Array<JobItemListModel>();
        }

        public async doInitAsync(): Promise<void> {
            let jobs = await this._getSyncJobsAsync();
            jobs.forEach(u => this._jobList.push(u));
        }

        public doRender() {
            let self = this;


            let dataGridContainer = $("<div>").appendTo(this.container);

            let store = new DevExpress.data.ArrayStore({
                key: 'jobKey',
                data: this._jobList
            });

            dataGridContainer.dxDataGrid({
                dataSource: {
                    store: store,
                    sort: 'jobKey'
                },

                columnResizingMode: "widget",
                columnFixing: { enabled: true },

                allowColumnResizing: true,
                allowColumnReordering: true,
                rowAlternationEnabled: true,
                searchPanel: { visible: true },
                columnChooser: { enabled: true },
                filterRow: {
                    visible: true
                },
                export: {
                    enabled: true
                },
                groupPanel: {
                    visible: true
                },
                scrolling: {
                    mode: "virtual"
                },

                width: "100%",

                columns: [
                    {
                        caption: "Actions",
                        allowSorting: false,
                        cellTemplate: function (container, options) {
                            self._buildActionsCell(container, options.data);
                        },
                        width: 75
                    },
                    {
                        dataField: 'jobKey',
                        dataType: 'string',
                        caption: 'Job Key',
                        allowSorting: true,
                        width: 200
                    },
                    {
                        dataField: 'isRegistered',
                        dataType: 'boolean',
                        caption: 'Registered',
                        allowSorting: true,
                        width: 100
                    },
                    {
                        dataField: 'nextRun',
                        dataType: 'string',
                        caption: "Next Run",
                        allowSorting: true,
                        width: 200,
                    },
                    {
                        dataField: 'prevRun',
                        dataType: 'string',
                        caption: 'Previous Run',
                        allowSorting: true,
                        width: 200,
                    },                    
                ]
            });

            this._dataGrid = dataGridContainer.dxDataGrid("instance");
        }

        private _buildActionsCell(container, syncJob) {
            let columnDiv = container;

            let jobBtn = $("<a>").appendTo(columnDiv);            
            $("<span class='fa fa-play'>").appendTo(jobBtn);
            jobBtn.attr("title", "Run Job");

            let self = this;

            jobBtn.click(function () {
                self._triggerSyncJobAsync(syncJob.jobKey).then((res) => {
                    Solovis.UI.alert(res, syncJob.jobKey, () => {                        
                        self._refreshSyncJobsAsync();                        
                    });
                })
            });
        }

        private async _triggerSyncJobAsync(jobKey): Promise<any> {
            let result = await Solovis.Rpc.invokeAndWait("~/Admin/EvestmentSync/TriggerJob", { jobKey: jobKey });
            if (result && result.result && result.result.triggerMessage) {
                return result.result.triggerMessage;
            }
        }

        private async _getSyncJobsAsync(): Promise<Array<any>> {
            let result = await Solovis.Rpc.invokeAndWait("~/Admin/EvestmentSync/GetSyncItems", {});
            if (result && result.result && result.result.items) {
                return result.result.items.map(u => new JobItemListModel(u));
            }
        }

        private async _refreshSyncJobsAsync(): Promise<void> {
            let self = this;

            const refreshedJobs = await self._getSyncJobsAsync();

            this._jobList = refreshedJobs;
            let store = new DevExpress.data.ArrayStore({ key: 'jobKey', data: this._jobList });
            this._dataGrid.option("dataSource", store);
        }

    }
}